import React from "react";
import Layout from "../../components/common/Layout";
import { FINANCE_NAV  } from "../../utils/navigation";

import DashboardCards from "../../components/finance/DashboardCards";
import PayrollSummary from "../../components/finance/PayrollSummary";
import ExpenseSummary from "../../components/finance/ExpenseSummary";
import TravelSummary from "../../components/finance/TravelSummary";
import PendingApprovals from "../../components/finance/PendingApprovals";
import RecentTransactions from "../../components/finance/RecentTransactions";

const FinanceDashboard = () => {
  return (
    <Layout navItems={FINANCE_NAV } panelLabel="Admin Panel">
      <div className="page-header">
        <div>
          <h1 className="page-title">Finance Dashboard</h1>
          <p className="page-subtitle">
            Manage payroll, expenses and business travel. 
          </p>
        </div>
      </div>

      <DashboardCards />

      <div className="dashboard-grid">
        <PayrollSummary />
        <ExpenseSummary />
        <TravelSummary />
      </div>

      <div className="dashboard-grid">
        <PendingApprovals />
        <RecentTransactions />
      </div>
    </Layout>
  );
};

export default FinanceDashboard;